import React from "react";
import ScheduleViewer from "../components/viewer/ScheduleViewer";
const ScheduleViewerPage = () => {
    return <div>
        <ScheduleViewer />
    </div>;
    };
export default ScheduleViewerPage;